// eslint-disable-next-line no-unused-vars
import styles from "../../../../styles/selectBar.css";

const SELECT_STYLE = {
  height: "42px",
  padding: "0 16px",
  fontSize: "0.9rem",
  fontWeight: 600,
  fontFamily: "inherit",
  color: "#3A434E",
  width: "180px",
  border: "1.5px solid #E6EDEC",
  borderRadius: "999px",
  cursor: "pointer",
  backgroundColor: "#F4F8F7",
  outline: "none",
};

// 지인에듀 수학 사이트 학습지 종류(2026-10-06 회신). api/assignment/views.py 의 MATH_WORKSHEET_TYPE_LIST 와 같다
const MATH_TYPE_OPTION_LIST = [
  { value: "type_worksheet", label: "유형 학습지" },
  { value: "drill", label: "연산 드릴" },
  { value: "variant", label: "변형문제" },
  { value: "concept", label: "개념 학습지" },
];

// 수학 계정의 출제 문제지 목록. 낸 과제의 종류(Worksheet.type)로 거른다. 기본은 전체
const MATH_ASSIGNED_OPTION_LIST = [
  { value: "math_type_worksheet", label: "유형 학습지" },
  { value: "math_drill", label: "연산 드릴" },
  { value: "math_variant", label: "변형문제" },
  { value: "math_concept", label: "개념 학습지" },
  { value: "math_wrong_note", label: "오답노트" },
  { value: "paper", label: "지필과제" },
];

// mathAssigned: 수학 계정의 출제 목록(수학 학습지 종류 + 오답노트 + 지필과제)
// mathTypes: 수학 계정의 문제지 목록. 수학 학습지 종류만 둔다
const WorksheetSelectBar = ({ typeSelect, setTypeSelect, mathAssigned = false, mathTypes = false }) => {
  if (mathTypes) {
    return (
      <select id="typeSelect" value={typeSelect} onChange={(e) => setTypeSelect(e.target.value)} className="customSelect" style={SELECT_STYLE}>
        <option value="all">학습지 종류 전체</option>
        {MATH_TYPE_OPTION_LIST.map((one) => (
          <option key={one.value} value={one.value}>
            {one.label}
          </option>
        ))}
      </select>
    );
  }
  if (mathAssigned) {
    return (
      <select id="typeSelect" value={typeSelect} onChange={(e) => setTypeSelect(e.target.value)} className="customSelect" style={SELECT_STYLE}>
        <option value="all">학습지 종류 전체</option>
        {MATH_ASSIGNED_OPTION_LIST.map((one) => (
          <option key={one.value} value={one.value}>
            {one.label}
          </option>
        ))}
      </select>
    );
  }
  return (
    <select
      id="typeSelect"
      value={typeSelect}
      onChange={(e) => setTypeSelect(e.target.value)}
      style={SELECT_STYLE}
      className="customSelect"
    >
      <option value="all">학습지 종류 전체</option>
      <option value="analysis">지문분석 워크북</option>
      <option value="comprehensive">내용이해 워크북</option>
      <option value="paragraph">모의고사 유형</option>
      <option value="vocabulary">단어</option>
      <option value="sentence">문장</option>
      <option value="grammar">어법</option>
      <option value="paper">지필과제</option>
      <option value="bank">문제뱅크</option>
      <option value="leveltest">레벨테스트</option>
    </select>
  );
};

export default WorksheetSelectBar;
